export type GWRequestType = {
    key: string;
    value: string;
    gid: string;
};

type GWResult = {
    key: string;
    value: string;
    gid: string;
    timestamp: string;
};

export type GWResponseType = {
    d: {
        results: GWResult[];
    };
};

export interface ConcurrentUsageDbData {
    key: string;
    payload: string;
    deleted: number;
    timestamp: number;
}

export enum ConcurrentUsageEntryState {
    PRESENT = 0,
    DELETED = 1,
}
